export default {
  name: 'SHPermission',
  data() {
    return {
      apis:{
        menus:'sh/menu/tree',//菜单树
        loadCheckMenus: 'sh/role/menus',//获取当前角色拥有的菜单列表
        loadCheckBtns:'sh/role/btn/keys',//获取当前角色拥有的按钮列表
      },
      menus:[],//所有菜单列表
      checkMenus:[],//选中的菜单
      checkBtns:[],//选中的功能按钮
    };
  },
  props: {
    isEdit:false,
    roles:{
      type:Array,
      default:function(){
        return [];
      }
    }
  },
  watch: {
    roles:{
      deep:true,
      handler(){
        this.initBtns();
        this.initMenus();
      }
    }
  },
  mounted: function () {
    this.loadPermissions();
    this.initMenus();
    this.initBtns();
  },
  methods: {
    getMenus(){//获取选中的菜单主键列表
      return this.checkMenus;
    },
    getBtns(){//获取选中的按钮主键列表
      return this.checkBtns;
    },
    initMenus(){//初始化菜单
        const me = this;
        me.checkMenus = [];
        if(me.hasRole()){
          me.$post({
            url: me.apis.loadCheckMenus,
            params:{
              keys : me.roles
            }
          }).then(rsp => {
            if(rsp.success){
              me.checkMenus = rsp.retList;
            }
          })
        }
    },
    initBtns(){//初始化按钮
      const me = this;
      me.checkBtns = [];
      if(me.hasRole()){
        me.$post({
          url: me.apis.loadCheckBtns,
          params:{
            keys : me.roles
          }
        }).then(rsp => {
          if(rsp.success){
            me.checkBtns = rsp.retList;
          }
        })
      }
    },
    hasRole(){
      const me = this;
      return me.roles && me.roles.length > 0;
    },
    loadPermissions(){
        const me = this;
        me.$post({
          url:me.apis.menus,
          params:{status: 1}
        }).then(rsp => {
          me.menus = rsp.retObj;
        })
    },
    moduleChange(md){
      const me = this, menus = md.subs, key = md.menu.id, btns = md.btns;
      if(menus && menus.length > 0){
        const index = me.checkMenus.indexOf(key);
        for(let i in menus){
          let m = menus[i];
          let j = me.checkMenus.indexOf(m.menu.id);
          if(index >= 0){
              j < 0 && me.checkMenus.push(menus[i].menu.id);
          }else{
              j >= 0 && me.checkMenus.splice(j, 1);
          }
          me.menuChange(m)
        }
      }
      // 改变模块直接按钮的选中状态
      if(btns && btns.length > 0){
        me.menuChange(md);
      }
    },
    menuChange(menu){
      const me = this, btns = menu.btns, key = menu.menu.id;
      if(!btns || btns.length <= 0){
        return;
      }
      const index = me.checkMenus.indexOf(key);
      for(let i in btns){
        let b = btns[i];
        let j = me.checkBtns.indexOf(b.id);
        if(index >= 0){
            j < 0 && me.checkBtns.push(b.id);
        }else{
            j >= 0 && me.checkBtns.splice(j, 1);
        }
      }

    },
    isModuleIndeterminate(md){//判断模块是否半选状态
      const me = this, menus = md.subs, key = md.menu.id;
      if(!menus || menus.length <= 0){
        return false;
      }
      //权限子节点数量，半选子节点数量
      let ret = false, allCheckSub = 0, halfCheckSub = 0;
      for(let i in menus){
        let menu = menus[i];
        if(me.checkMenus.indexOf(menu.menu.id) >= 0){
          if(me.isIndeterminate(menu)){
            halfCheckSub += 1;
          }else{
            allCheckSub += 1;
          }
        }
      }
      if(allCheckSub + halfCheckSub > 0 && me.checkMenus.indexOf(key) < 0){
        me.checkMenus.push(key);
      }
      return halfCheckSub > 0 || (allCheckSub > 0 && allCheckSub < menus.length);
    },
    isIndeterminate(menu){//判断菜单是否半选状态
      const me = this, btns = menu.btns, key = menu.menu.id;
      if(!btns || btns.length <= 0){
        return false;
      }
      let checked = 0;
      for(let i in btns){
        if(me.checkBtns.indexOf(btns[i].id) >= 0){
          checked += 1;
        }
      }
      if(checked > 0 && me.checkMenus.indexOf(key) < 0){
        me.checkMenus.push(key);
      }
      return (checked > 0 && checked != btns.length) || (checked == 0 && me.checkMenus.indexOf(key) >= 0);
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/role/permission/src/permission.js